export { ProgressBar } from './progress/ProgressBar.js';
export type { ProgressBarProps } from './progress/ProgressBar.js';
export type { ProgressBarIconProps } from './progress/ProgressBarIcon.js';
export type { ProgressBarLabelProps } from './progress/ProgressBarLabel.js';
export type { ProgressBarValueProps } from './progress/ProgressBarValue.js';
export { ProgressCircle } from './progress/ProgressCircle.js';
export type { ProgressCircleProps } from './progress/ProgressCircle.js';
export { Skeleton } from './skeleton/Skeleton.js';
export type { SkeletonProps } from './skeleton/Skeleton.js';
export { SkeletonText } from './skeleton/SkeletonText.js';
export type { SkeletonTextProps } from './skeleton/SkeletonText.js';
export { Accordion } from './accordion/Accordion.js';
export type {
  AccordionControlledProps,
  AccordionOwnProps,
  AccordionProps,
  AccordionUncontrolledProps,
  OnChangeValue,
  SingleExpanded,
  MultiExpanded,
} from './accordion/accordion-types.js';
export type {
  AccordionSectionProps,
  AccordionSectionOwnProps,
} from './accordion/AccordionSection.js';
export { FeatureHighlight } from './feature-highlight/FeatureHighlight.js';
export type { InformationContentProps } from './information-overlay/Content.js';
export type {
  InformationOverlayBaseProps,
  InformationOverlayControlledProps,
  InformationOverlayProps,
  InformationOverlayUncontrolledProps,
} from './information-overlay/InformationOverlay.js';
export type { InformationOverlayIconProps } from './information-overlay/InformationOverlayIcon.js';
export { InformationOverlay } from './information-overlay/InformationOverlay.js';
export type { InformationOverlayTriggerProps } from './information-overlay/Trigger.js';
export { Microguide } from './microguide/Microguide.js';
export type { MicroguideProps } from './microguide/Microguide.js';
export type { ContentProps } from './shared-components/Content.js';

export type { TitleProps } from './shared-components/Title.js';
export type { VisualProps } from './shared-components/Visual.js';

export type {
  FeatureHighlightProps,
  FeatureHighlightPlacement,
} from './feature-highlight/FeatureHighlight.js';

export { TerminologyOverlay } from './terminology-overlay/TerminologyOverlay.js';
export type { TerminologyDescriptionProps } from './terminology-overlay/Description.js';
export type { TerminologyOverlayProps } from './terminology-overlay/TerminologyOverlay.js';
export type { TerminologyOverlayTriggerProps } from './terminology-overlay/Trigger.js';

export { AvatarGroup } from './avatar-group/AvatarGroup.js';
export type { AvatarGroupProps } from './avatar-group/AvatarGroup.js';
export type {
  AvatarGroupItemOwnProps,
  AvatarGroupItemProps,
} from './avatar-group/Item.js';
export { Avatar } from './avatar/Avatar.js';
export type { AvatarOwnProps, AvatarProps } from './avatar/Avatar.js';
export type { AvatarLabelProps } from './avatar/Label.js';
export type { AvatarSubtitleProps } from './avatar/Subtitle.js';

//#region ChipGroup
export { ChipGroup } from './chip-group/ChipGroup.js';
export type {
  ChipGroupBaseProps,
  ChipGroupControlledProps,
  ChipGroupUncontrolledProps,
  ChipGroupProps,
} from './chip-group/ChipGroup.js';
export type { ChipGroupControlProps } from './chip-group/Control.js';
export { useChipGroupContext } from './chip-group/hooks/useChipGroupContext.js';
export type { ChipGroupContextProps } from './chip-group/contexts/ChipGroupContext.js';
//#endregion

//#region Chip
export { Chip } from './chip/Chip.js';
export type { ChipContentProps } from './chip/ChipContent.js';
export type { ChipDeleteButtonProps } from './chip/ChipDeleteButton.js';
export type { ChipKeyProps } from './chip/ChipKey.js';
export type { ChipOwnProps, ChipProps } from './chip/types/chip.js';
//# endregion

export { CodeSnippet } from './code-snippet/CodeSnippet.js';
export type { HighlightLanguage } from './code-snippet/HighlightExtended.js';
export type {
  CodeSnippetHeightProps,
  CodeSnippetProps,
} from './code-snippet/CodeSnippet.js';
export type { CodeSnippetCopyProps } from './code-snippet/actions-menu/Copy.js';
export type { CodeSnippetDownloadProps } from './code-snippet/actions-menu/Download.js';
export { prismDqlLanguage } from './code-snippet/prism-dql-language.js';

export { ExpandableText } from './expandable-text/ExpandableText.js';
export type {
  ExpandableTextBaseProps,
  ExpandableTextControlledProps,
  ExpandableTextProps,
  ExpandableTextUncontrolledProps,
} from './expandable-text/ExpandableText.js';

export { KeyboardShortcutTooltip } from './keyboard-shortcut-tooltip/KeyboardShortcutTooltip.js';
export type { KeyboardShortcutTooltipProps } from './keyboard-shortcut-tooltip/KeyboardShortcutTooltip.js';
export { KeyboardShortcut } from './keyboard-shortcut/KeyboardShortcut.js';
export type { KeyboardShortcutProps } from './keyboard-shortcut/KeyboardShortcut.js';

export { Markdown, componentMappings } from './markdown/Markdown.js';
export type {
  MarkdownProps,
  MarkdownSelection,
  MarkdownSelectionPoint,
} from './markdown/markdown-types.js';

export { EmptyState } from './empty-state/EmptyState.js';
export type {
  EmptyStateProps as GenericEmptyStateProps,
  EmptyStateVisualPresetProps,
} from './empty-state/types/empty-state-types.js';
export type { EmptyStateActionsProps } from './empty-state/slot-components/Actions.js';
export type { EmptyStateDetailsProps } from './empty-state/slot-components/Details.js';
export type { EmptyStateFooterProps } from './empty-state/slot-components/Footer.js';
export type { EmptyStateTitleProps } from './empty-state/slot-components/Title.js';
export type { EmptyStateVisualProps } from './empty-state/slot-components/Visual.js';
// NOTE: possibly have to rename

export { HealthIndicator } from './health-indicator/HealthIndicator.js';
export type { HealthIndicatorProps } from './health-indicator/health-indicator-types.js';
export type { HealthIndicatorVisualProps } from './health-indicator/Visual.js';
export type { HealthIndicatorLabelProps } from './health-indicator/Label.js';

export { MessageContainer } from './message-container/MessageContainer.js';
export type { MessageContainerProps } from './message-container/MessageContainer.types.js';
export type { MessageContainerActionsProps } from './message-container/Actions.js';
export type { MessageContainerDescriptionProps } from './message-container/Description.js';
export type { MessageContainerPrefixProps } from './message-container/Prefix.js';
export type { MessageContainerTitleProps } from './message-container/Title.js';

export {
  AiLoadingIndicator,
  type AiLoadingIndicatorProps,
} from './ai-loading-indicator/AiLoadingIndicator.js';
export { type AiLoadingIndicatorIconProps } from './ai-loading-indicator/AiLoadingIndicatorIcon.js';

export { AiResponse } from './ai-response/AiResponse.js';
export type { AiResponseProps } from './ai-response/AiResponse.js';
export type { AiResponseCodeBlockProps } from './ai-response/ai-response-types.js';

export {
  ReleasePhaseIndicator,
  type ReleasePhaseIndicatorProps,
  type ReleasePhase,
} from './release-phase-indicator/ReleasePhaseIndicator.js';
